import React, { useState, useEffect } from 'react';
import { object, func, array, bool } from 'prop-types';
import { get, map, find, omit, isEmpty } from 'lodash';
import { FormInput, DrawerHeader, Text, FlexContainer, Button, FormSelect, Row, Column } from '../../common';
import { withApollo } from 'react-apollo';
import CREATE_SECTOR_PICKING from '../../graphql/createSectorPicking';
import UPDATE_SECTOR_PICKING from '../../graphql/updateSectorPicking';
import { Collapse, Divider } from 'antd';
import styled from 'styled-components';

const NewSectorPicking = ({
    client,
    toggleDrawer,
    setOpened,
    updateSelectedSectorPicking,
    sectorsPickingData,
    visible
}) => {
    const [sectorPickingName, setSectorPickingname] = useState('');
    const [loadingEdit, setLoadingEdit] = useState(false);
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [createErrorMessage, setCreateErrorMessage] = useState(false);
    const [editSuccessMessage, setEditSuccessMessage] = useState(false);
    const [editErrorMessage, setEditErrorMessage] = useState(false);
    const [selectedSectorPicking, setSelectedSectorPicking] = useState(null);
    const [sectorPicking, setSectorPicking] = useState({});
    const [sectorPickingId, setSectorPickingId] = useState(null);

    useEffect(() => {
        if (sectorPickingId) {
            const sectorPickingFound = find(sectorsPickingData, { id: sectorPickingId });
            setSectorPicking(sectorPickingFound);
            setSelectedSectorPicking({ value: sectorPickingId, label: get(sectorPickingFound, 'sectorPicking') });
        };
    }, [sectorsPickingData]);

    const SelectIcon = styled.div`
        margin-left: auto;
        margin-top: auto;
        margin-bottom: auto;
        padding: 0px 5px;
        font-size: .2rem;
        color: ${({ color = 'black' }) => color};

        &:hover {
            color: green;
        }
    `;

    const FooterWrapper = styled(Column)`
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        padding: 15px;
        border-top: 1px solid #eaeaea;
        background-color: #ffffff;
    `;

    const positionLabels = [
        { label: '', app: 'Nombre App', web: 'Nombre Web' },
        { label: 'Pasillo', app: 'aisleLabelAbbreviation', web: 'aisleLabel' },
        { label: 'Primer nivel', app: 'positionLabelAbbreviation', web: 'positionLabel' },
        { label: 'Segundo Nivel', app: 'placeLabelAbbreviation', web: 'placeLabel' },
        { label: 'Tercer Nivel', app: 'trayLabelAbbreviation', web: 'trayLabel' }
    ];

    const iconCollpase = (isActive) => {
        return (
            <a><SelectIcon className={`icon-ic-fat-arrow-${isActive ? 'up' : 'down'}`} color='#4cb358' /></a>
        );
    };

    const sectorPickingOptions = map(sectorsPickingData, ({ id: value, sectorPicking: label }) => {
        return { value, label };
    });

    const onChangeSectorPicking = (item, from, value) => {
        cleanMessages();
        setSectorPicking({ ...sectorPicking, [get(item, from)]: value });
    };

    const itemFormPosition = (item, from, readOnly, sectorPickingItem) => {
        if (!get(item, 'label')) return <Text text={get(item, from)} />;
        if (readOnly) return <Text truncate text={get(sectorPickingItem, get(item, from)) || '-'} />;
        return <FormInput
            maxLength={from === 'app' ? 3 : 40}
            value={get(sectorPicking, get(item, from)) || ''}
            onChange={(event) => onChangeSectorPicking(item, from, get(event, 'target.value'))}
        />;
    };

    const formPosition = (readOnly, sectorPickingItem) => {
        return (<>
            {map(positionLabels, (item, index) => {
                return (
                    <Row key={index}>
                        <Column justify='center'>
                            <Text text={get(item, 'label')} />
                        </Column>
                        { readOnly && <Divider type='vertical' style={{ height: 30 }} /> }
                        <Column justify='center'>
                            {itemFormPosition(item, 'app', readOnly, sectorPickingItem)}
                        </Column>
                        <Column mL={10} justify='center'>
                            {itemFormPosition(item, 'web', readOnly, sectorPickingItem)}
                        </Column>
                    </Row>
                );
            })}
        </>);
    };

    const validateBtnSave = () => {
        return (
            (get(sectorPicking, 'aisleLabelAbbreviation') && get(sectorPicking, 'aisleLabel')) ||
            (get(sectorPicking, 'positionLabelAbbreviation') && get(sectorPicking, 'positionLabel')) ||
            (get(sectorPicking, 'placeLabelAbbreviation') && get(sectorPicking, 'placeLabel')) ||
            (get(sectorPicking, 'trayLabelAbbreviation') && get(sectorPicking, 'trayLabel'))
        );
    };

    const cleanMessages = () => {
        setCreateErrorMessage(false);
        setEditSuccessMessage(false);
        setEditErrorMessage(false);
    };

    const formCreateSectorPicking = () => {
        return (<>
            <FormInput
                label='Nuevo sector picking'
                value={sectorPickingName}
                onChange={event => {
                    cleanMessages();
                    setSectorPickingname(get(event, 'target.value', null));
                }}
            />
            {createErrorMessage && <Row>
                <Column mB={10}>
                    <Text color='#db5959' text={'El sector ya existe o hubo un error en su creación. Favor intente nuevamente'} />
                </Column>
            </Row>}
            <FlexContainer justify='flex-end'>
                <Button
                    text={'Crear'}
                    width={85}
                    loading={loadingCreate}
                    disabled={isEmpty(sectorPickingName)}
                    onClick={() => {
                        setLoadingCreate(true);
                        client.mutate({
                            mutation: CREATE_SECTOR_PICKING,
                            variables: {
                                input: { sectorPicking: sectorPickingName }
                            },
                            refetchQueries: ['getSectorPicking']
                        }).then(({ data }) => {
                            const internalCode = get(data, 'createSectorPicking.internalCode');
                            if (internalCode !== '200') {
                                setCreateErrorMessage(true);
                            } else {
                                setSectorPickingId(get(data, 'createSectorPicking.id'));
                                updateSelectedSectorPicking();
                            }

                            setLoadingCreate(false);
                        });
                    }}
                />
            </FlexContainer>
        </>);
    };

    const footer = () => {
        return (
            <FooterWrapper>
                {editSuccessMessage && <Row justify='flex-end' mB={10}>
                    <Text color='#4cb358' text={'El sector se editó correctamente'} />
                </Row>}
                {editErrorMessage && <Row justify='flex-end' mB={10}>
                    <Text color='#db5959' text={'Hubo un error al editar sector. Favor intente nuevamente'} />
                </Row>}
                <Row justify='flex-end'>
                    <Button text='Cancelar' secondary onClick={() => setOpened()} right={16} width={85} />
                    <Button
                        disabled={!validateBtnSave()}
                        text='Guardar'
                        width={85}
                        onClick={() => onConfirm()}
                        loading={loadingEdit}
                    />
                </Row>
            </FooterWrapper>
        );
    };

    const onConfirm = () => {
        setLoadingEdit(true);
        client.mutate({
            mutation: UPDATE_SECTOR_PICKING,
            variables: { input: omit(sectorPicking, ['__typename', 'status']) },
            refetchQueries: ['getSectorPicking']
        }).then(({ data }) => {
            setSectorPickingId(null);

            if (get(data, 'editSectorPicking.internalCode') === '200') {
                setEditSuccessMessage(true);
                updateSelectedSectorPicking();
            } else {
                setEditErrorMessage(true);
            };

            setLoadingEdit(false);
        });
    };

    return (
        <>
            <FlexContainer flex={1} direction='column'>
                <DrawerHeader title={'Sector Picking'} onClose={() => toggleDrawer()} />
                {formCreateSectorPicking()}
                <FormSelect
                    label='Sectores existentes'
                    options={sectorPickingOptions}
                    onChange={({ value }) => {
                        cleanMessages();
                        setSectorPicking(find(sectorsPickingData, { id: get(value, 'value') }));
                        setSelectedSectorPicking(value);
                    }}
                    value={selectedSectorPicking}
                />
                {!isEmpty(selectedSectorPicking) && formPosition()}
                <FlexContainer flex={1} direction='column' pB={50} mT={10}>
                    { map(sectorsPickingData, (item, index) => {
                        return (
                            <Collapse
                                key={index}
                                showArrow={false}
                                bordered={false}
                                accordion
                                expandIconPosition='right'
                                forceRender
                                expandIcon={({ isActive }) => iconCollpase(isActive)}>
                                <Collapse.Panel header={`${get(item, 'sectorPicking')}`} style={{ fontSize: 12 }} key={index}>
                                    {formPosition(true, item)}
                                </Collapse.Panel>
                            </Collapse>
                        );
                    })}
                </FlexContainer>
            </FlexContainer>
            {footer()}
        </>
    );
};

NewSectorPicking.propTypes = {
    client: object,
    toggleDrawer: func,
    setOpened: func,
    updateSelectedSectorPicking: func,
    sectorsPickingData: array,
    visible: bool
};

export default withApollo(NewSectorPicking);
